import './styles.scss'
import React, { useState, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { shorten as shortenAPI, EcommerceAPI } from 'api'
import { Collapse, Button } from 'reactstrap'
import { withModule } from 'hocs'

import { composerAct } from 'redux/actions'
import { getStaticImage } from 'utils/statics'

const configCredentialURL = '/dashboard/configurations/credentials?activeKey=shopify'

const PluginEcommerce = (props) => {
  const { isRemoveUser, userId } = props

  const history = useHistory()
  const dispatch = useDispatch()

  const [cardOpen, setCardOpen] = useState(false)
  const [openEcommerce, setOpenEcommerce] = useState(false)
  const [ecommerce, setEcommerce] = useState(null)
  const [shopInfo, setShopInfo] = useState(null)

  useEffect(() => {
    if (cardOpen) {
      EcommerceAPI.getShopInfo()
        .then(({ data: shopInfo }) => {
          shopInfo.domain = `https://${shopInfo.domain}`
          setShopInfo(shopInfo)
        })
        .catch(() => {
          setShopInfo(null)
        })
    }
  }, [userId, cardOpen])

  useEffect(() => {
    if (openEcommerce) {
      const conversation = document.querySelector('.conversation')
      const rect = conversation.getBoundingClientRect()
      const positionX = rect.x + (window.screenX >= window.screen.width ? window.screenX - window.screen.width : window.screenX)
      const positionY = (window.outerHeight - window.innerHeight) + (window.screenY >= window.screen.height ? window.screenY - window.screen.height : window.screenY) + rect.y

      ecommerce.moveBy(positionX, positionY)
      ecommerce.resizeBy(rect.width, rect.height)

      const timer = setInterval(function () {
        if (ecommerce.closed) {
          clearInterval(timer)
          setOpenEcommerce(false)
          setCardOpen(false)
          window.removeEventListener("message", messageListener)
        }
      }, 500)

      window.addEventListener("message", messageListener)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ecommerce])

  const messageListener = async (event) => {
    if (event.origin !== shopInfo.domain) return
    let resultUrl
    try {
      resultUrl = (await shortenAPI.shortOneURL(event.data)).url || event.data
    } catch (error) {
      console.error('ecommerce short', error.message)
    }

    if (shopInfo.message) {
      dispatch(composerAct.updateMsgFromExternalText(shopInfo.message))
    }

    dispatch(
      composerAct.updateButtons([{
        type: 'url',
        label: I18n.t('ecommerce_btn_go_store'),
        content: resultUrl
      }])
    )

    window.removeEventListener("message", messageListener)
  }

  const toggleCard = () => {
    setCardOpen(isRemoveUser ? false : !cardOpen)
  }

  const toggleEcommerce = () => {
    setOpenEcommerce(true)
    setEcommerce(window.open(shopInfo.domain, "", "rezisable"))
  }

  const sendPostMessage = () => {
    ecommerce.postMessage('get-url', shopInfo.domain)
    setOpenEcommerce(false)
    setCardOpen(false)
  }

  return (
    <div className={`plugin-ecommerce-card ${isRemoveUser ? 'disabled' : ''}`}>
      <div className='title-container'>
        <div
          className='title'
          onClick={toggleCard}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-cart-dark.svg')} alt='Ecommerce' />
          </figure>
          <p>{I18n.t('dashboard_ecommerce')}</p>
        </div>
        <div
          className='action-buttons-container'
          onClick={toggleCard}
        >
          <i className={`fa fa-chevron-${cardOpen ? 'up' : 'down'}`} />
        </div>
      </div>
      <Collapse isOpen={cardOpen}>
        <div className='ecommerce-container'>
          <div className='separator'></div>
          {!shopInfo
            ? <Button color='danger' onClick={() => history.push(configCredentialURL)}>{I18n.t('dashboard_setup-ecommerce')}</Button>
            : <>
              {!openEcommerce && <Button color='primary' onClick={toggleEcommerce}>{I18n.t('ecommerce_btn_open_store')}</Button>}
              {openEcommerce && <Button color='primary' onClick={sendPostMessage}>{I18n.t('ecommerce_btn_get_link')}</Button>}
            </>}
        </div>
      </Collapse>
    </div>
  )
}

export default withModule(PluginEcommerce, 'pluginEcommerce')
